const facebookData = {
  facebookBtnTxt: 'Facebook Login',
};

export default facebookData;



// WEBPACK FOOTER //
// ./src/components/registration-login/vx-facebook-login/vx-facebook-login-i18n.js